module.exports = __webpack_public_path__ + "media/icon/icon-door-lock-box-green-ea497a34.svg";